import MainDealBoard from "../components/deals-board/main-deal-board";

function DealBoard() {
    return(<div><MainDealBoard/></div>)
}

export default DealBoard;